import getHelper from '../../../services/getHelper';

import Policy from '../types/Policy';

export default getHelper<Policy>('/policies/:id');
